import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SurveyEditorService {
  public isUsingQuestions: boolean;
  public isUsingTips: boolean;
  public isUsingPopups: boolean;
  public isUsingActions: boolean;

  constructor() {
    this.isUsingQuestions = this.isUsingTips = this.isUsingPopups = this.isUsingActions = false;
   }

  useQuestions() {
    this.isUsingQuestions = true;
  }
  
  useTips() {
    this.isUsingTips = true;
  }
  
  usePopups() {
    this.isUsingPopups = true;
  }

  useActions(){
    this.isUsingActions = true;
  }
}
